export default __webpack_public_path__ + "static/media/schedule.c5d8135e.svg";